import api from './axiosInstance';

export const reportApi = {
  getDashboard: (from, to, orgUnitId) =>
    api.get('/reports/dashboard', {params: {from, to, orgUnitId}}),

  getInsights: (from, to, orgUnitId) =>
    api.get('/reports/insights', {params: {from, to, orgUnitId}}),

  getMonthlyData: (year, orgUnitId) =>
    api.get('/reports/monthly', {params: {year, orgUnitId}}),

  getSales: (from, to, orgUnitId) =>
    api.get('/reports/sales', {params: {from, to, orgUnitId}}),

  getPayments: (from, to, orgUnitId) =>
    api.get('/reports/payments', {params: {from, to, orgUnitId}}),

  getDues: (from, to, statuses, orgUnitId) =>
    api.get('/reports/dues', {params: {from, to, statuses, orgUnitId}}),
};
